// ─── WIP Filter Types & Defaults ─────────────────────────────────────────────
// Separated from WipFilterSheet.tsx so that non-component exports don't
// interfere with React Fast Refresh (HMR).

export interface WipFilters {
  groupBy: string;           // 'none' | 'resource' | 'date' | 'costCentre'
  dateFrom: Date | undefined;
  dateTo: Date | undefined;
  type: string;              // 'all-types' | 'time' | 'expense' | 'invoice'
  resources: string[];       // [] = all resources
  showWrittenOff: boolean;
}

export const DEFAULT_WIP_FILTERS: WipFilters = {
  groupBy: 'none',
  dateFrom: undefined,
  dateTo: undefined,
  type: 'all-types',
  resources: [],
  showWrittenOff: false,
};

export function countActiveWipFilters(filters: WipFilters): number {
  let count = 0;
  if (filters.groupBy !== 'none') count++;
  if (filters.dateFrom) count++;
  if (filters.dateTo) count++;
  if (filters.type !== 'all-types') count++;
  if (filters.resources.length > 0) count++;
  if (filters.showWrittenOff) count++;
  return count;
}
